import * as React from 'react';

// Essential JSX runtime exports
export function jsx(type, props, key) {
  return React.createElement(type, { ...props, key });
}

export function jsxs(type, props, key) {
  return React.createElement(type, { ...props, key });
}

export const Fragment = React.Fragment;
export default { jsx, jsxs, Fragment };